import React from 'react'
import { CrossIcon } from '../../../Svgs/Svg'

export default function RcfHeader({ brandSettingsData, getImageUrl, storeName, isOnSite }) {
    return (
        <div className="d-flex justify-content-between align-items-center w-100 sticky-top bg-white border-bottom border-gray-300  px-3">
            <div
                className="rcf-main-heading"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px",
                }}
            >
                {brandSettingsData?.generalAppearance?.logo ? (
                <img
                   src={getImageUrl(brandSettingsData?.generalAppearance?.logo)}
                   alt="Description"
                   style={{
                     height: "75px",
                     objectFit: "contain",
                     aspectRatio: "4 / 2",
                   }}
                 />                 
                ) : (
                    storeName ?? "Store logo"
                )}
            </div>
            {isOnSite === false ? (
                <div style={{ marginTop: "10px" }}></div>
            ) : (
                <div
                    className="cross-icon text-end c-pointer"
                    onClick={() => {
                        setTimeout(
                            () =>
                                window.parent.postMessage(
                                    { showRcf: true },
                                    "*"
                                ),
                            200
                        )
                    }}
                >
                    <CrossIcon />
                </div>
            )}
        </div>
    )
}
